export const systemFlowDiagram = {
  id: "system-flow",
  title: "System Flow Diagram",
  description:
    "Interactive diagram showing the system architecture and data flow. Explore the connections between different components and understand how data moves through the system.",
  nodes: [
    {
      id: "ods",
      type: "custom",
      data: { label: "ODS" },
      position: { x: 50, y: 100 },
    },
    {
      id: "patientStore",
      type: "custom",
      data: { label: "Patient Store" },
      position: { x: 300, y: 100 },
    },
    {
      id: "eventQueue1",
      type: "custom",
      data: { label: "Event Queue" },
      position: { x: 500, y: 100 },
    },
    {
      id: "eventQueue2",
      type: "custom",
      data: { label: "Event Queue", rotation: 270 },
      position: { x: 220, y: 180 },
    },
    {
      id: "bestNextAction",
      type: "custom",
      data: { label: "Best Next Action" },
      position: { x: 800, y: 100 },
    },
    {
      id: "lumerisEngage",
      type: "custom",
      data: { label: "Lumeris Engage" },
      position: { x: 120, y: 320 },
    },
    {
      id: "aiAssistant",
      type: "custom",
      data: { label: "AI Agent" },
      position: { x: 500, y: 320 },
    },
    {
      id: "member",
      type: "custom",
      data: { label: "Patient" },
      position: { x: 800, y: 320 },
    },
  ],
  edges: [
    {
      id: "ods-patientStore",
      source: "ods",
      target: "patientStore",
      type: "step",
      animated: true,
      label: "Member Data",
    },
    {
      id: "patientStore-eventQueue1",
      source: "patientStore",
      target: "eventQueue1",
      type: "step",
      animated: true,
    },
    {
      id: "eventQueue1-bestNextAction",
      source: "eventQueue1",
      target: "bestNextAction",
      type: "step",
      animated: true,
      label: "Event Trigger",
    },
    {
      id: "bestNextAction-lumerisEngage",
      source: "bestNextAction",
      target: "lumerisEngage",
      type: "step",
      animated: true,
      label: "Program + Prioritized Topics",
    },
    {
      id: "lumerisEngage-aiAssistant",
      source: "lumerisEngage",
      target: "aiAssistant",
      type: "step",
      animated: true,
      label: "Create Assignment",
    },
    {
      id: "aiAssistant-member",
      source: "aiAssistant",
      target: "member",
      type: "step",
      animated: true,
    },
    {
      id: "lumerisEngage-eventQueue2",
      source: "lumerisEngage",
      target: "eventQueue2",
      type: "step",
      animated: true,
      label: "Outcome of Pathway action",
    },
    {
      id: "eventQueue2-bestNextAction",
      source: "eventQueue2",
      target: "patientStore",
      type: "step",
      animated: true,
    },
  ],
};
